import { ReservationContractTemplateFileFieldIdentifier } from '@mews-commander/data-access';

export enum TemplateFormStepFields {
    templateOptionsFields = 'templateOptionsFields',
    dataMappingFields = 'dataMappingFields',
}

export enum DataMappingCategories {
    ReservationDetail = 'ReservationDetail',
    GuestProfile = 'GuestProfile',
    GuestAdditional = 'GuestAdditional',
    GuestAddress = 'GuestAddress',
}

export const dataMappingCategoriesMap = {
    [DataMappingCategories.GuestProfile]: [
        ReservationContractTemplateFileFieldIdentifier.Email,
        ReservationContractTemplateFileFieldIdentifier.Title,
        ReservationContractTemplateFileFieldIdentifier.FirstName,
        ReservationContractTemplateFileFieldIdentifier.FirstLastName,
        ReservationContractTemplateFileFieldIdentifier.SecondLastName,
        ReservationContractTemplateFileFieldIdentifier.Nationality,
        ReservationContractTemplateFileFieldIdentifier.Language,
        ReservationContractTemplateFileFieldIdentifier.Telephone,
        ReservationContractTemplateFileFieldIdentifier.Sex,
        ReservationContractTemplateFileFieldIdentifier.DateOfBirth,
        ReservationContractTemplateFileFieldIdentifier.PlaceOfBirth,
    ],
    [DataMappingCategories.GuestAdditional]: [
        ReservationContractTemplateFileFieldIdentifier.TaxIdentifier,
        ReservationContractTemplateFileFieldIdentifier.CardRegistrationNumber,
        ReservationContractTemplateFileFieldIdentifier.Occupation,
        ReservationContractTemplateFileFieldIdentifier.Company,
    ],
    [DataMappingCategories.GuestAddress]: [
        ReservationContractTemplateFileFieldIdentifier.FullAddress,
        ReservationContractTemplateFileFieldIdentifier.StreetMain,
        ReservationContractTemplateFileFieldIdentifier.StreetAdditional,
        ReservationContractTemplateFileFieldIdentifier.City,
        ReservationContractTemplateFileFieldIdentifier.PostalCode,
        ReservationContractTemplateFileFieldIdentifier.Country,
        ReservationContractTemplateFileFieldIdentifier.StateOrProvince,
    ],
    [DataMappingCategories.ReservationDetail]: [
        ReservationContractTemplateFileFieldIdentifier.ReservationOwner,
        ReservationContractTemplateFileFieldIdentifier.Service,
        ReservationContractTemplateFileFieldIdentifier.SpaceCategory,
        ReservationContractTemplateFileFieldIdentifier.RoomNumber,
        ReservationContractTemplateFileFieldIdentifier.ConfirmationNumber,
        ReservationContractTemplateFileFieldIdentifier.ArrivalDate,
        ReservationContractTemplateFileFieldIdentifier.ArrivalTime,
        ReservationContractTemplateFileFieldIdentifier.DepartureDate,
        ReservationContractTemplateFileFieldIdentifier.DepartureTime,
        ReservationContractTemplateFileFieldIdentifier.Rate,
        ReservationContractTemplateFileFieldIdentifier.TotalAmount,
        ReservationContractTemplateFileFieldIdentifier.AverageBookableServiceRate,
        ReservationContractTemplateFileFieldIdentifier.AverageBookableServiceWithProductsRate,
    ],
} as const;

export const TEMPLATE_CATEGORY_OPTION_LABEL_PREFIX = 'ContractTemplateTabCategoryOptionLabel';
export const TEMPLATE_IDENTIFIER_OPTION_LABEL_PREFIX = 'ContractTemplateTabIdentifierOptionLabel';
